import axios from '@/lib/axios';
import { CancelRequestParams } from '../types';

const confirmCancel = (data: CancelRequestParams, custCode: string | undefined) => {
  return axios.post(`/facility/facility_agreements/terminate_cancels/${custCode}/cancel_confirm`, data);
}

export default confirmCancel;